function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/* eslint-disable react/forbid-prop-types */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Message } from "../..";
import { getRest } from "../../utils";

/**
 * ToastErreur.
 *
 * @author Nicolas EICHERS
 * @class ToastErreur
 * @extends {React.Component}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ToastErreur = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ToastErreur, _React$Component);
  /**
     * Creates an instance of ToastErreur.
     *
     * @author Nicolas EICHERS
     * @param {*} args
     * @memberof ToastErreur
     */
  function ToastErreur() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    /**
       * Handle close icon click.
       *
       * @memberof ToastErreur
       */
    _this.handleMinify = function (e, data) {
      _this.setState({
        minified: true
      });
      _.invoke(_this.props, 'onMinify', e, data);
    };
    /**
       * Handle minified toast click.
       *
       * @memberof ToastErreur
       */
    _this.handleGrow = function (e, data) {
      _this.setState({
        minified: false
      });
      _.invoke(_this.props, 'onGrow', e, data);
    };
    /**
       * Handle error item click and gives focus + scroll to the targeted input.
       *
       * @memberof ToastErreur
       */
    _this.handleErrorClick = function (e, item) {
      var containerRef = _this.props.containerRef;
      if (_this.timeoutScroll) {
        window.clearTimeout(_this.timeoutScroll);
        _this.timeoutScroll = null;
      }
      if (!_.isNil(item.idHtml)) {
        var target = document.getElementById(item.idHtml);
        var position = null;
        if (!_.isNil(target)) {
          position = target.getBoundingClientRect();
        }

        // si le champs est déjà visible à l'écran
        if (!_.isNil(position) && position.top >= 0 && position.bottom <= window.innerHeight) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          });
          target.focus({
            preventScroll: true
          });
        } else {
          // peut être dans un panel fermé
          // ouverture du panel
          var pane = _.split(item.idHtml, '-');

          // le pane[0] doit correspondre au panel où se trouve le champs
          if (pane.length > 1 && !_.isNil(containerRef)) {
            containerRef.dispatchEvent(new Event("state-" + pane[0]));
          }
          _this.timeoutScroll = window.setTimeout(function () {
            if (!_.isNil(target)) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              });
              target.focus({
                preventScroll: true
              });
            }
          }, 50);
        }
      }
      _.invoke(_this.props, 'onErrorClick', e, item);
    };
    /**
       * Handle errors click.
       *
       * @memberof ToastErreur
       */
    _this.handleErrorsClick = function (item) {
      return function (e) {
        return _this.handleErrorClick(e, item);
      };
    };
    /**
       * Render the list item of message.
       *
       * @memberof ToastErreur
       */
    _this.renderList = function () {
      var list = _this.props.list;
      return /*#__PURE__*/_jsx(Message.List, {
        style: {
          maxHeight: 110,
          overflowY: 'auto',
          paddingRight: 10,
          width: '103%'
        },
        children: _.map(list, function (item) {
          return _.isPlainObject(item) ? /*#__PURE__*/_jsx(Message.Item, {
            style: {
              textDecoration: 'underline',
              cursor: 'pointer'
            },
            onClick: _this.handleErrorsClick(item),
            children: item.libelle
          }, "toast-" + item.idHtml) : /*#__PURE__*/_jsx(Message.Item, {
            children: item
          }, _.uniqueId());
        })
      });
    };
    _this.state = {
      /** Whether or not the toast is minified. */
      minified: false
    };
    return _this;
  }

  /**
     *
     * @author Nicolas EICHERS
     * @memberof ToastErreur
     */
  var _proto = ToastErreur.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timeoutScroll) {
      clearTimeout(this.timeoutScroll);
      this.timeoutScroll = null;
    }
  };
  /**
     * Render the component.
     *
     * @author Nicolas EICHERS
     * @returns
     * @memberof ToastErreur
     */
  _proto.render = function render() {
    var _this$props = this.props,
      header = _this$props.header,
      content = _this$props.content,
      list = _this$props.list,
      iconProps = _this$props.icon;
    var minified = this.state.minified;
    var rest = getRest(ToastErreur, this.props);
    var icon = !_.isNil(iconProps) ? iconProps : 'warning sign';
    if (minified) {
      return /*#__PURE__*/_jsx(Button, Object.assign({
        error: true,
        circular: true,
        size: "big",
        icon: {
          name: icon,
          link: true
        }
      }, rest, {
        onClick: this.handleGrow
      }));
    }
    var titre = header;
    if (_.isEmpty(titre)) {
      if (_.isNil(list) || !_.isEmpty(list) && list.length <= 1) {
        titre = 'Une erreur est survenue';
      } else {
        titre = list.length + " erreurs sont survenues";
      }
    }
    if (!_.isEmpty(list)) {
      return /*#__PURE__*/_jsx(Message, Object.assign({
        content: this.renderList(),
        error: true,
        header: titre + "\xA0\xA0",
        icon: icon
      }, rest, {
        onDismiss: this.handleMinify
      }));
    }
    return /*#__PURE__*/_jsx(Message, Object.assign({
      content: content,
      error: true,
      header: titre + "\xA0\xA0",
      icon: icon
    }, rest, {
      onDismiss: this.handleMinify
    }));
  };
  return ToastErreur;
}(React.Component);
/**
 * Proptypes.
 */
ToastErreur.handledProps = ["containerRef", "content", "header", "icon", "list", "onErrorClick", "onGrow", "onMinify"];
ToastErreur.propTypes = {
  /** Content. */
  content: PropTypes.node,
  /** Title of toast */
  header: PropTypes.string,
  /** Icon of toast. */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** List of items to display in toast content. */
  list: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
    idHtml: PropTypes.string.isRequired,
    libelle: PropTypes.string.isRequired
  }))]),
  /** Callback on an error click. */
  onErrorClick: PropTypes.func,
  /** Callback on minified toast click. */
  onGrow: PropTypes.func,
  /** Callback on close icon click. */
  onMinify: PropTypes.func,
  /** Container Ref. */
  containerRef: PropTypes.object
};
export default ToastErreur;